module.exports = __webpack_public_path__ + "img/Blue Spirit-256.a7f6cbd6.png";